import { NavigateBackLinkWithHistory } from '@exam-management/components';
import { QBankStructureLevelCategory } from '@exam-management/graphql';
import { PageHeader } from '@shared/components';
import { useMemo } from 'react';
import { useLocation, matchPath } from 'react-router-dom';

import { useQuestionReviewTaskQuestionDetails } from '../../providers';

export default function QuestionReviewTaskQuestionDetailsPageHeader() {
  const { pathname } = useLocation();

  const { question, qBankStructureLevels, qBankStructureLevelItems, mainTaskDetails } =
    useQuestionReviewTaskQuestionDetails();

  const courseItem = useMemo(() => {
    const courseLevelItem = qBankStructureLevels.find(
      (structureLevel) => structureLevel.category === QBankStructureLevelCategory.Course,
    );
    return qBankStructureLevelItems.find(
      (item) => item.qBankStructureLevelId === courseLevelItem?.id,
    );
  }, [qBankStructureLevels, qBankStructureLevelItems]);

  const matchedMyTask = matchPath('/my-task/*', pathname);
  const backPath = matchedMyTask
    ? '/my-task/question-review/:taskId'
    : '/task-management/question-review/:taskId';

  return (
    <PageHeader
      title={question.refCode}
      subtitleSection={courseItem?.tag?.name ?? ''}
      linkAdornment={
        <NavigateBackLinkWithHistory
          fallbackPath={backPath}
          matchPatterns={backPath}
          fallbackParams={{ taskId: mainTaskDetails.id }}
          label='Back'
        />
      }
    />
  );
}
